'use client';

import { useEffect } from 'react';

import { Error as ErrorPage } from '@/components/Error/Error';
import { recoverFromChunkLoadError } from '@/utils/chunk-load-recovery';
import { logError } from '@/utils/log-error';

export default function Error({
  reset,
  error
}: {
  reset: () => void;
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    if (error.message === 'NEXT_NOT_FOUND') return;

    // A stale deploy can reference chunks that 404. Recover with a one-time hard
    // reload (which `reset()` cannot do) before falling back to the error page.
    if (recoverFromChunkLoadError(error)) return;

    logError(error, {
      component: 'ErrorPage',
      digest: error.digest
    });
  }, [error]);

  return <ErrorPage reset={reset} />;
}
